import React from 'react';
import './style.css';
export default function GreyInfo(props) {
    var _a;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 'normal';
    return (React.createElement("span", { className: "grey-info-container", style: {
            fontSize: size === 'normal' ? '1em'
                : size === 'small' ? '.85rem'
                    : '.7rem',
        } }, props.children));
}
